import {h} from "preact";


export function LivePage({children}) {
	return <div class="cl-live-page flex min-w-0 grow flex-col ml-3">{children}</div>
}

export function TopRowContainer({children}) {
	return <div class="cl-toprow-cont flex h-8 flex-none items-center border-b text-xs border-b-blue-whale-800 bg-blue-whale-900 dark:text-zinc-400 dark:border-b-zinc-950 dark:bg-zinc-800">{children}</div>
}

export function ContainerLink({children}) {
	return <div class="cl-cont-link flex grow">{children}</div>
}

export function TopPageLink({children, href, onClick, active}) {
	if (active)
		return <a class="cl-toppage-link px-4 capitalize text-kobaaccent-500" href={href} onClick={onClick}>{children}</a>
	return <a class="cl-toppage-link px-4 capitalize text-slate-300 dark:text-zinc-400" href={href} onClick={onClick}>{children}</a>
}

export function SearchBarSection({children}) {
	return <div class="cl-srch-bar-sect flex h-full w-72 justify-end">{children}</div>
}

export function SearchBarWrapper({children}) {
	return <div class="cl-srch-bar-wrap h-full w-64 flex-none p-1.5">{children}</div>
}

export function SearchBarContainer({children}) {
	return null; // <div class="cl-srch-bar-cont h-full w-full border border-zinc-950 bg-zinc-900">{children}</div>
}

export function TopRowIcon({children}) {
	return <div class="cl-toprow-icon flex h-full w-9 flex-none items-center justify-center border-l border-l-zinc-900">{children}</div>
}

export function SportScrollBar({children}) {
	return <div class="mt-3 rounded-xl bg-slate-100"><div class="cl-sport-scroll-bar scrollbar-x-fancy w-full flex-none items-stretch overflow-x-auto overflow-y-hidden">{children}</div></div>
}

export function SportsContainer({children}) {
	return <div class="cl-sports-cont flex h-full min-w-full text-slate-950 rounded-xl">{children}</div>
}

export function SportButton({children, active, onClick}) {
	return <div 
			   class={"cl-live-sport-btn flex h-[4.5rem] shrink-0 grow-0 flex-col items-center justify-center px-4 cursor-pointer relative"}
			   onClick={onClick}>
		{children}
	</div>
}

export function SportIcon({children}) {
	return <div class="cl-live-sport-icon relative h-8 w-8 bg-white">{children}</div>
}

export function SportName({children}) {
	return <div class="cl-live-sport-name text-xs">{children}</div>
}

export function LiveSportContainer({children}) {
	return <div class="cl-live-sport-cont scrollbar-fancy min-h-0 mt-2 dark:mt-0 rounded-xl dark:rounded-none grow overflow-y-scroll bg-slate-400 dark:bg-zinc-900">{children}</div>
}

export function CurrentSportNameRow({children, sportid = null}) {
	return <div data-sportid={sportid} class="cl-live-sport-name-row sticky top-0 z-50 flex py-1 w-full items-center justify-between bg-slate-100 border-b border-b-slate-300 px-2 text-base text-slate-950 uppercase">{children}</div>
}

export function CurrentSportName({children}) {
	return <div class="cl-live-curr-sport-name px-2">{children}</div>
}

export function LiveEventsContainer({children}) {
	return <div class="cl-live-evt-cont fn-live-events">{children}</div>
}

export function TournamentNameRow({children}) {
	return <div class="cl-live-tourn-name-row flex h-7 items-center justify-start bg-slate-200 text-slate-950 px-2">{children}</div>
}

export function FlagContainer({children}) {
	return <div class="cl-live-flag-cont bandiera h-4 w-6 flex items-center justify-center">{children}</div>
}

export function TournamentName({children}) {
	return <div class="cl-tourn-name px-2 text-sm truncate flex-shrink-0">{children}</div>
}

export function FullEventRow({children}) {
	return <div class="cl-live-full-evt-row flex h-fit px-2 items-stretch bg-slate-100 text-slate-950 border-b border-slate-200">{children}</div>
}

export function InfoSportContainer({children, onClick}) {
	return <div class="cl-live-infosport-cont w-2/5 flex-none px-1" onClick={onClick}>{children}</div>
}

export function InfoSportContainerClickable({children, onClick}) {
	return <div class="cl-live-infosport-cont w-2/5 flex-none px-1 py-1.5 cursor-pointer" onClick={onClick}>{children}</div>
}

export function InfoSportRow({children}) {
	return <div class="cl-live-infosport-row flex text-xs mt-2">{children}</div>
}

export function Minutes({children}) {
	return <div class="cl-live-minutes text-xs relative top-px pr-1 py-px leading-none text-slate-600 font-bold">{children}</div>
}

export function Phase({children}) {
	return <div class="cl-live- grow px-1.5 text-kobaaccent-600">{children}</div>
}

export function MarketsNumber({children}) {
	return <div class="cl-live-mkt-minutes px-1">{children}</div>
}

export function InfoTeamRow({children}) {
	return <div class="cl-live-info-team-row mt-1 flex items-start justify-start">{children}</div>
}

export function TeamName({children}) {
	return <div class="cl-live-team-name truncate">{children}</div>
}

export function TeamScoreContainer({children}) {
	return <div class="cl-live-team-score-cont flex items-center px-0.5">{children}</div>
}

export function TeamScore({children}) {
	return <div class="cl-live-team-score px-0.5 text-lg font-bold text-kobaaccent-500">{children}</div>
}

export function DashScore({children}) {
	return <div class="cl-live-dash-score ">{children}</div>
}

export function SpaceDiv({children}) {
	return <div class="cl-live-space-div grow">{children}</div>
}

export function SportItemContainer({children}) {
	return <div class="cl-live-sportitem-cont relative top-px mr-0.5 h-4 w-4 flex items-center justify-center">{children}</div>
}

export function HiddenNotifyContainer({children}) {
	return <div class="cl-live-hidd-notf-cont w-3/5 flex-none bg-slate-100 text-slate-950">{children}</div>
}

export function HiddenNotify({children}) {
	return <div class="cl-live-hidd-notf flex h-full w-full items-center justify-center text-sm text-zinc-950">{children}</div>
}

export function MarketResultContainer({children}) {
	return <div class="cl-live-mtch-result-cont flex w-3/5 flex-none flex-col bg-slate-100 text-slate-950">{children}</div>
}

export function MarketResultRow({children}) {
	return <div class="cl-live-mtch-result-row relative flex h-6 w-full items-center bg-slate-100 text-slate-950 cursor-pointer hover:text-kobaaccent-500">{children}</div>
}

export function DropdownButton({children, onClick}) {
	return <div class="cl-live-select-btn flex h-full w-7 items-center justify-center" onClick={onClick}>{children}</div>
}

export function MarketResult({children, onClick}) {
	return <div class="cl-live-mtch-result px-2 pb-0.5 text-sm cursor-pointer" onClick={onClick}>{children}</div>
}

export function DropdownHiddenContainer({children, active, ref}) {
	if (active)
		return <div class="cl-live-select-hidd-container absolute top-full z-10 w-64" ref={ref}>{children}</div>
	return null;// <div class="absolute top-full z-10 w-52 border-t border-t-zinc-950">{children}</div>
}

export function DropdownRow({children, onClick, active}) {
	if (active)
		return <div class="cl-live-select-row h-7 border border-slate-300 bg-slate-200 px-2 text-xs flex items-center text-slate-950 truncate cursor-pointer">{children}</div>
	return <div class="cl-live-select-row h-7 border border-slate-300 bg-slate-100 px-2 text-xs flex items-center text-slate-950 truncate hover:bg-slate-200 cursor-pointer" onClick={onClick}>{children}</div>
}

export function OutcomeButtonContainer({children}) {
	return <div class="cl-live-out-btn-cont flex bg-slate-100 py-2 gap-2 text-sm">{children}</div>
}

export function OutcomeButton({children}) {
	return <div class="cl-live-out-btn flex h-8 grow items-center justify-between bg-slate-100 px-4 first:border-l-0 overflow-x-hidden">
		<span class="truncate">Outcome</span>
		<span class="font-bold text-kobaaccent-500">3.10</span>
	</div>
}

function LivePageExample() {
	return <Fragment>
		<div class="flex h-screen border-b border-b-zinc-950 bg-zinc-900 text-white">
		  <LivePage>
		    <TopRowContainer>
		      <ContainerLink>
		        <TopPageLink>general view</TopPageLink>
		        <TopPageLink>event view</TopPageLink>
		        <TopPageLink>sport home</TopPageLink>
		      </ContainerLink>
		      <SearchBarSection>
		        <SearchBarWrapper>
		          <SearchBarContainer></SearchBarContainer>
		        </SearchBarWrapper>
		      </SearchBarSection>
		      <TopRowIcon></TopRowIcon>
		      <TopRowIcon></TopRowIcon>
		      <TopRowIcon></TopRowIcon>
		    </TopRowContainer>
		    <SportScrollBar>
		      <SportsContainer>
		        <SportButton>
		          <SportIcon>I</SportIcon>
		          <SportName>Favorites</SportName>
		        </SportButton>
		        <SportButton>
		          <SportIcon>I</SportIcon>
		          <SportName>Favorites</SportName>
		        </SportButton>
		        <SportButton>
		          <SportIcon>I</SportIcon>
		          <SportName>Favorites</SportName>
		        </SportButton>
		      </SportsContainer>
		    </SportScrollBar>
		    <LiveSportContainer>
		      <CurrentSportNameRow>
		        <CurrentSportName>Football</CurrentSportName>
		      </CurrentSportNameRow>
		      <LiveEventsContainer>
		        <TournamentNameRow>
		          <FlagContainer></FlagContainer>
		          <TournamentName>Tournament Name</TournamentName>
		        </TournamentNameRow>
		        <FullEventRow>
		          <InfoSportContainer>
		            <InfoSportRow>
		              <Minutes>16</Minutes>
		              <Phase>Half 1</Phase>
		              <MarketsNumber>36</MarketsNumber>
		            </InfoSportRow>
		            <InfoTeamRow>
		              <TeamName>Apollon Limassol</TeamName>
		              <TeamScoreContainer>
		                <TeamScore>4</TeamScore>
		                <DashScore>-</DashScore>
		                <TeamScore>0</TeamScore>
		              </TeamScoreContainer>
		              <TeamName>Apollon Limassol</TeamName>
		              <SpaceDiv></SpaceDiv>
		              <SportItemContainer></SportItemContainer>
		            </InfoTeamRow>
		          </InfoSportContainer>
		          <HiddenNotifyContainer>
		            <HiddenNotify>Sorry, no odds for this match</HiddenNotify>
		          </HiddenNotifyContainer>
		          <MarketResultContainer>
		            <MarketResultRow>
		              <DropdownButton>D</DropdownButton>
		              <MarketResult>Match Result</MarketResult>
		              <DropdownHiddenContainer>
		                <DropdownRow>Match Result</DropdownRow>
		                <DropdownRow>Match Result</DropdownRow>
		                <DropdownRow>Match Result</DropdownRow>
		                <DropdownRow>Match Result</DropdownRow>
		                <DropdownRow>Match Result</DropdownRow>
		              </DropdownHiddenContainer>
		            </MarketResultRow>
		            <OutcomeButtonContainer>
		              <OutcomeButton></OutcomeButton>
		              <OutcomeButton></OutcomeButton>
		              <OutcomeButton></OutcomeButton>
		            </OutcomeButtonContainer>
		          </MarketResultContainer>
		        </FullEventRow>
		      </LiveEventsContainer>
		    </LiveSportContainer>
		  </LivePage>
		  <div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-zinc-950">
		    MENU DESTRA
		  </div>
		</div>
	</Fragment>
}
